/* ============================================
   Forest Hero | Custom Components JS
   ============================================ */

(function() {
  'use strict';

  /* ------------------------------------------
     Window Height Variable (for sidebar on mobile)
     ------------------------------------------ */
  var rootHeight = document.getElementById('root-height');
  if (rootHeight) {
    var setWindowHeight = function() {
      rootHeight.innerHTML = ':root { --window-height: ' + window.innerHeight + 'px; }';
    };
    setWindowHeight();
    window.addEventListener('resize', setWindowHeight);
  }

  /* ------------------------------------------
     FH | Landing Header — scroll effect
     ------------------------------------------ */
  var landingHeader = document.querySelector('.fh-landing-header');
  if (landingHeader) {
    var scrollThreshold = 10;
    var isScrolled = false;

    function checkScroll() {
      var shouldBeScrolled = window.scrollY > scrollThreshold;
      if (shouldBeScrolled !== isScrolled) {
        isScrolled = shouldBeScrolled;
        landingHeader.classList.toggle('scrolled', isScrolled);
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll(); // Initial check
  }

  /* ------------------------------------------
     Helper: find scroll target by ID or product handle
     ------------------------------------------ */
  function findTarget(id) {
    if (!id) return null;
    // First try direct ID match
    var el = document.getElementById(id);
    if (el) return el;
    // Then try matching a product card by data-product-handle
    var card = document.querySelector('.product-item[data-product-handle="' + id + '"]');
    if (card) return card;
    // Fallback: partial handle match (e.g. "kapsule" matches "bio-lions-mane-kapsule")
    var allCards = document.querySelectorAll('.product-item[data-product-handle]');
    for (var i = 0; i < allCards.length; i++) {
      if (allCards[i].dataset.productHandle.indexOf(id) !== -1) return allCards[i];
    }
    return null;
  }

  /* ------------------------------------------
     Helper: get sticky offset (header + nav)
     ------------------------------------------ */
  function getStickyOffset() {
    var header = document.querySelector('.header--sticky, [data-js-site-header]');
    var headerH = header ? header.offsetHeight : 0;
    var stickyNav = document.querySelector('.fh-page-nav');
    var navH = stickyNav ? stickyNav.offsetHeight : 0;
    return headerH + navH + 16;
  }

  /* ------------------------------------------
     FH | Page Navigation — sticky + active tracking
     ------------------------------------------ */
  var nav = document.querySelector('.fh-page-nav');
  if (nav) {
    var pills = nav.querySelectorAll('.fh-page-nav__pill');
    var navTargets = [];

    // Pill click — smooth scroll
    pills.forEach(function(pill) {
      var id = pill.dataset.navTarget;
      var el = findTarget(id);
      if (el) navTargets.push({ pill: pill, el: el });

      pill.addEventListener('click', function(e) {
        var target = findTarget(id);
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - getStickyOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // Intersection Observer — active pill tracking
    if (navTargets.length) {
      var track = nav.querySelector('.fh-page-nav__track');
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            pills.forEach(function(p) { p.classList.remove('is-active'); });
            var match = navTargets.find(function(t) { return t.el === entry.target; });
            if (match) {
              match.pill.classList.add('is-active');
              // Horizontally scroll the pill track only (not the page)
              if (track) {
                var pillLeft = match.pill.offsetLeft;
                var pillWidth = match.pill.offsetWidth;
                var trackWidth = track.offsetWidth;
                var scrollTarget = pillLeft - (trackWidth / 2) + (pillWidth / 2);
                track.scrollTo({ left: scrollTarget, behavior: 'smooth' });
              }
            }
          }
        });
      }, { rootMargin: '-30% 0px -60% 0px' });

      navTargets.forEach(function(t) { observer.observe(t.el); });
    }
  }

  /* ------------------------------------------
     FH | Helper Cards — scroll, highlight, select
     Works for both format-helper and mushroom-helper
     ------------------------------------------ */
  var cards = document.querySelectorAll('.fh-helper__card[data-scroll-target]');

  cards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      var targetId = card.dataset.scrollTarget;
      if (!targetId) return;

      var target = findTarget(targetId);
      if (!target) return; // No target on page — let href navigate normally

      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - getStickyOffset();
      window.scrollTo({ top: top, behavior: 'smooth' });

      // Highlight target
      target.classList.add('fh-highlight');
      setTimeout(function() { target.classList.remove('fh-highlight'); }, 2000);

      // Mark selected card
      var siblings = card.closest('.fh-helper__grid').querySelectorAll('.fh-helper__card');
      siblings.forEach(function(c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
    });
  });

  /* ------------------------------------------
     FH | FAQ Accordion
     ------------------------------------------ */
  var faqButtons = document.querySelectorAll('[data-fh-faq-toggle]');

  faqButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.fh-faq__item');
      var answer = item.querySelector('.fh-faq__answer');
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.setAttribute('hidden', '');
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
      }
    });

    // Keyboard: Enter and Space
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  });

  /* ------------------------------------------
     FH | Bundle Upsell — Quick Add to Cart
     ------------------------------------------ */
  var quickAddButtons = document.querySelectorAll('[data-fh-quick-add]');

  quickAddButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.classList.contains('is-loading')) return;

      var originalText = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = '...';
      btn.disabled = true;

      var cartAddUrl = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_add_url)
        ? KROWN.settings.routes.cart_add_url + '.js'
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
        body: 'id=' + variantId + '&quantity=1'
      })
      .then(function(res) {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then(function() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓';

        // Refresh cart contents from server
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }

        // Open cart drawer - will show updated content when refresh completes
        var cartDrawer = document.getElementById('site-cart-sidebar');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
        }

        setTimeout(function() {
          btn.classList.remove('is-added');
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function() {
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });

  /* ------------------------------------------
     FH | Product Accordion Toggle (mushroom product sections)
     ------------------------------------------ */
  var productAccButtons = document.querySelectorAll('[data-fh-product-acc-toggle]');

  productAccButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var content = btn.nextElementSibling;
      if (!content) return;

      var isOpen = btn.classList.contains('is-open');

      // Toggle state
      btn.classList.toggle('is-open', !isOpen);
      content.classList.toggle('is-open', !isOpen);
    });
  });

  /* ------------------------------------------
     FH | Sticky Bar + Back-to-Top Button
     Appears when hero scrolls out of view
     ------------------------------------------ */
  var stickyBar = document.querySelector('.fh-sticky-bar');
  var backTopBtn = document.querySelector('.fh-back-top');

  if (stickyBar) {
    var triggerSelector = stickyBar.dataset.trigger || 'hero';
    var triggerElement = document.getElementById(triggerSelector);

    if (triggerElement && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function(entries) {
        var isInView = entries[0].isIntersecting;
        var shouldShow = !isInView;

        stickyBar.classList.toggle('is-visible', shouldShow);
        if (backTopBtn) {
          backTopBtn.classList.toggle('is-visible', shouldShow);
        }
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      stickyObserver.observe(triggerElement);
    }
  }

  /* ------------------------------------------
     FH | Mushroom Product — Format Selector
     Dynamic switching between product formats
     ------------------------------------------ */
  var productSwitchers = document.querySelectorAll('[data-fh-product-switcher]');

  productSwitchers.forEach(function(card) {
    var selector = card.querySelector('[data-fh-format-selector]');
    if (!selector) return;

    var buttons = selector.querySelectorAll('.fh-format-selector__btn');
    var img = card.querySelector('.fh-mushroom-product__card-img');
    var nameEl = card.querySelector('.fh-mushroom-product__card-name');
    var formatEl = card.querySelector('.fh-mushroom-product__card-format');
    var priceOldEl = card.querySelector('.fh-mushroom-product__price-old');
    var priceNewEl = card.querySelector('.fh-mushroom-product__price-new');
    var buyBtn = card.querySelector('.fh-mushroom-product__buy');

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var format = btn.dataset.format; // 'primary' or 'secondary'
        var isActive = btn.classList.contains('is-active');

        if (isActive) return; // Already active, do nothing

        // Update button states
        buttons.forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        // Fade out
        card.classList.add('is-switching');

        setTimeout(function() {
          // Update content using data attributes
          if (img) {
            img.src = card.dataset[format + 'Image'];
            img.srcset = card.dataset[format + 'Srcset'];
            img.alt = card.dataset[format + 'Title'];
          }

          if (nameEl) {
            nameEl.textContent = card.dataset[format + 'Title'];
          }

          if (formatEl) {
            formatEl.textContent = card.dataset[format + 'Format'];
          }

          if (priceOldEl) {
            var priceOld = card.dataset[format + 'PriceOld'];
            if (priceOld && priceOld !== '') {
              priceOldEl.textContent = priceOld;
              priceOldEl.style.display = 'inline';
            } else {
              priceOldEl.textContent = '';
              priceOldEl.style.display = 'none';
            }
          }

          if (priceNewEl) {
            priceNewEl.textContent = card.dataset[format + 'PriceNew'];
          }

          if (buyBtn) {
            var variantId = card.dataset[format + 'Variant'];
            var available = card.dataset[format + 'Available'] === 'true';

            buyBtn.dataset.variantId = variantId;

            if (available) {
              buyBtn.disabled = false;
              buyBtn.textContent = buyBtn.dataset.defaultText || 'Naroči z 10 % popustom';
            } else {
              buyBtn.disabled = true;
              buyBtn.textContent = 'Razprodano';
            }
          }

          // Fade back in
          card.classList.remove('is-switching');
        }, 150); // Match CSS transition time
      });
    });
  });

  /* ------------------------------------------
     FH | Cart Drawer Handler (Landing Page)
     ------------------------------------------ */
  document.querySelectorAll('[data-js-sidebar-handle]').forEach(function(btn) {
    var sidebarId = btn.getAttribute('aria-controls');
    if (!sidebarId) return;

    var sidebar = document.getElementById(sidebarId);
    if (!sidebar) return;

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      btn.setAttribute('aria-expanded', 'true');
      if (typeof sidebar.show === 'function') {
        sidebar.show();
      }
    });
  });

  /* ------------------------------------------
     FH | Sidebar Close Handlers (Landing Page)
     Attach close handlers to all [data-js-close] buttons in sidebars
     ------------------------------------------ */
  document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var sidebar = btn.closest('sidebar-drawer');
      if (sidebar && typeof sidebar.hide === 'function') {
        sidebar.hide();
      }
    });
  });

})();
